import { types } from 'mobx-state-tree';

const form = types.model('BaseForm', {}).actions(self => ({
  set(fieldName, fieldValue) {
    self[fieldName] = fieldValue;
  }
}));

export { form };
